import differenceInCalendarYears from 'date-fns/differenceInCalendarYears';
import { policyType, policyType as PolicyType } from '@ourbranch/lookups';

export const getInitialValues = (prefillData, user, requestedPolicyType) => {
  const initialValues = {
    firstName: '',
    lastName: '',
    address: '',
    driversLicenseNumber: '',
    driversLicenseState: '',
    state: '',
    zip: '',
    city: '',
    unit: '',
    noUnitNumber: false,
    dateOfBirth: '',
    email: undefined,
    phone: undefined,
    leadSource: undefined,
    affinity: user?.affinityCode,
    rep: user?.username,
    VIN: '',
    priorAddress: {
      address: '',
      address2: '',
      state: '',
      zip: '',
      city: ''
    },
    home: {
      sqFt: undefined,
      ownershipStatus: undefined,
      homeQuality: undefined,
      typeOfHome: undefined,
      constructionType: undefined,
      exteriorWallType: undefined,
      garageType: undefined,
      roofShape: undefined,
      roofDeck: undefined,
      roofCover: undefined,
      roofDeckAttachment: undefined,
      roofToWallConnection: undefined,
      openingProtection: undefined,
      roofSWR: undefined,
      yearBuilt: undefined,
      numFireplaces: undefined,
      numWoodBurningStoves: undefined,
      numOccupants: undefined,
      numMortgages: undefined,
      numFullBathrooms: undefined,
      numHalfBathrooms: undefined,
      numStories: undefined,
      garageCarCapacity: undefined,
      numFamiliesInDwelling: undefined,
      roofYear: undefined,
      roofType: undefined,
      roofOriginal: undefined,
      purchaseDate: undefined,
      basementSqFt: undefined,
      basementType: undefined,
      latitude: undefined,
      longitude: undefined,
      fireHydrantWithin1000ft: undefined,
      fpc: undefined,
      fpcFromLocation: undefined,
      wildfireHazardScore: undefined,
      wildfireGallagherScore: undefined,
      dtoName: undefined,
      dtbowName: undefined,
      dtbowLabel: undefined,
      stormShutters: undefined,
      fortifiedHome: undefined
    },
    condo: {
      yearBuilt: undefined,
      purchaseDate: undefined,
      monthsRentedOut: undefined,
      floor: undefined,
      typeOfEntry: 'I',
      hasBasement: false,
      buildingHasMoreThanFiveUnits: false,
      condoQuality: undefined,
      constructionType: undefined,
      numHalfBathrooms: undefined,
      numFullBathrooms: undefined,
      roofShape: undefined,
      sqFt: undefined,
      latitude: undefined,
      longitude: undefined
    },
    insuranceInPast31Days: false,
    priorCoverageInYears: '',
    policyLimitBIPD: '',
    fcraDisclaimer: false,
    isNewConstruction: false,
    isNewPurchase: false,
    livedAtThisAddressFor1Year: undefined,
    connectedHome: undefined,
    global: undefined,
    signUpForNewMonitoringService: false,
    optIntoMarketingCampaigns: false,
    policyType: policyType.HABundle,
    isApartment: false,
    overrides: {}
  };

  if (prefillData && Object.keys(prefillData).length > 0) {
    const {
      fname,
      lname,
      firstName,
      lastName,
      salesRep,
      correctedAddress: { address, city, state, zip } = {},
      priorAddress,
      email,
      phone,
      home,
      condo,
      drivers,
      leadSource,
      affinity,
      global,
      policyType,
      autoCoverage,
      // additional properties to support Simply IOA and other agencies who want links in batch files:
      // (these are shorter than full names to reduce the size of the batch file and stay in URL length limits)
      addr, // address
      ci, // city
      st, // state
      zi // zip
    } = prefillData;

    if (prefillData.fname || prefillData.firstName) {
      initialValues.firstName = fname || firstName;
    }
    if (lname || lastName) {
      initialValues.lastName = lname || lastName;
    }
    if (salesRep) {
      initialValues.rep = prefillData.salesRep;
    }
    if (drivers?.length) {
      initialValues.dateOfBirth = drivers[0]?.dateOfBirth;
      initialValues.driversLicenseNumber = drivers[0]?.driversLicenseNumber;
      initialValues.driversLicenseState = drivers[0]?.driversLicenseState;
    }

    if (addr || address) {
      initialValues.address = addr || address;
    }
    if (ci || city) {
      initialValues.city = ci || city;
    }
    if (st || state) {
      initialValues.state = st || state;
    }
    if (zi || zip) {
      initialValues.zip = zi || zip;
    }

    if (priorAddress) {
      initialValues.priorAddress = priorAddress;
    }

    if (autoCoverage?.policyLimitBIPD) {
      initialValues.policyLimitBIPD = autoCoverage?.policyLimitBIPD;
    }

    if (affinity || global?.affinity) {
      initialValues.affinity = affinity || global?.affinity;
    }

    if (home) {
      initialValues.home = home;
    }

    if (condo) {
      initialValues.condo = condo;
    }

    if (phone) {
      initialValues.phone = phone;
    }

    if (email) {
      initialValues.email = email;
    }

    if (leadSource) {
      initialValues.leadSource = leadSource;
    }

    initialValues.insuranceInPast31Days = !!global?.continuousAutoCoverageStartDate;

    initialValues.priorCoverageInYears = global?.continuousAutoCoverageStartDate
      ? Math.min(differenceInCalendarYears(new Date(), Date.parse(global?.continuousAutoCoverageStartDate)), 6)
      : '';

    initialValues.policyType = requestedPolicyType || prefillData?.selectedOption || policyType || PolicyType.HABundle;

    initialValues.noUnitNumber = prefillData?.selectedOption?.includes(PolicyType.Condo) && !prefillData?.hasUnitNumber;
  }

  return initialValues;
};
